<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container ml-5">
   <div>
    <div class="vx-row">

    <div  class="vx-row w-full" >



     <vx-card :title="$t('Organization')" class="mb-base ml-5 mr-5" >
       <div  class="vx-row flex"  >


      <div class="vx-col flex-1 " >
          <div class="vx-col flex-1"  v-if="viewLoginInfo">
                <vx-card :title="$t('LoginInfo')"  class="mt-base" no-shadow card-border>
                    <div  class="vx-col lg:center w-full" >
                      <div class="flex-1"  >
                            <vs-input :label="$t('UsernameRequired')" v-model="customerModel.Username" class="mt-5 w-full" name="Username" v-validate="'required'" />
                            <span class="text-warning text-sm">{{$t('ValidEmail')}}</span>
                            <br/>
                            <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>
                        </div>


                     <div class="flex-1 ">
                          <password  :model="customerModel"/>
                        </div>
                    </div>
                </vx-card>
            </div>
        <div class="flex-1" style="padding-left:10px" >
                <vx-card :title="$t('MainInfo')"  class="mt-base" no-shadow card-border>
                  <div  class="vx-col lg:center w-full" >

                <div class="flex-1" style="padding-left:5px">
                  <vs-input :label="$t('OrganizationName')" v-model="customerModel.FullName" class="mt-5 w-full" name="name" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                </div>


          <div class="flex-1 mt-5" style="padding-left:5px">
                <p>{{$t('NationalityRequired')}}</p>

                                     <v-select
                                          label="Name"
                                          class=" w-full"
                                            autocomplete
                                          v-model="customerModel.NationalityID"
                                          :options="nationalities"
                                          :reduce="ID => ID.ID"
                                        />

          <span class="text-danger text-sm"  v-show="errors.has('Nationality')">{{ errors.first('Nationality') }}</span>
        </div>
         <div class="flex-1 mt-5" style="padding-left:5px">
           <p>{{$t('Country')}} *</p>

                                     <v-select
                                          label="Name"
                                          class=" w-full"
                                            autocomplete
                                          v-model="customerModel.CountryID"
                                          :options="countries"
                                          :reduce="ID => ID.ID"
                                        />

          <span class="text-danger text-sm"  v-show="errors.has('Country')">{{ errors.first('Country') }}</span>
        </div>


                  </div>
                </vx-card>
          </div>

    <div class="vx-col w-full" style="padding-left:10px" >
      <vx-card :title="$t('JobInfo')" class="mt-base" no-shadow card-border>

         <div  class="vx-col w-full">

        <div class="flex-1" style="padding-left:5px">
          <p>{{$t('IndustrySector')}} *</p>

                                     <v-select
                                          label="Name"
                                          class=" w-full"
                                            autocomplete
                                          v-model="customerModel.IndustrySectorID"
                                          :options="industrySectors"
                                          :reduce="ID => ID.ID"
                                        />

          <span class="text-danger text-sm"  v-show="errors.has('IndustrySector')">{{ errors.first('IndustrySector') }}</span>
        </div>
         <div class="flex-1 mt-5" style="padding-left:5px">
           <p>{{$t('PreferredLanguage')}}</p>

                                     <v-select
                                          label="Name"
                                          class=" w-full"
                                            autocomplete
                                          v-model="customerModel.PreferredLanguageID"
                                          :options="languages"
                                          :reduce="ID => ID.ID"
                                        />

          <span class="text-danger text-sm"  v-show="errors.has('Language')">{{ errors.first('Language') }}</span>
        </div>
        </div>
        </vx-card>
         </div>

</div>
<div class="vx-col flex-1">
   <div class="flex-1" style="padding-left:10px">
    <vx-card :title="$t('PersonalInfo')" class="mt-base" no-shadow card-border>
      <div class="vx-col w-full" >
        <div class="flex-1" style="padding-left:5px">
             <p>{{$t('Title')}} *</p>
                <v-select
                  label="Name"
                  v-model="customerModel.UserTitleID"
                  :options="UserTitles"
                  autocomplete
                  class="w-full"
                  :reduce="value => value.ID"
                />
                  <span class="text-danger text-sm" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
                </div>
         <div class="flex-1" style="padding-left:5px">
            <vs-input :label="$t('ContactPersonName')" v-model="customerModel.ContactPersonName" class="mt-5 w-full" name="ContactPersonName" />
            <span class="text-danger text-sm" v-show="errors.has('ContactPersonName')">{{ errors.first('ContactPersonName') }}</span>
          </div>
       <div class="flex-1" style="padding-left:5px">
            <vs-input :label="$t('ContactPersonPhone')" v-model="customerModel.ContactPersonTelephone" class="mt-5 w-full" name="ContactPersonTelephone" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('ContactPersonTelephone')">{{ errors.first('ContactPersonTelephone') }}</span>
          </div>

          <div class="flex-1" style="padding-left:5px">
            <vs-input :label="$t('ContactPersonEmail')" v-model="customerModel.ContactPersonEmail" class="mt-5 w-full" name="ContactPersonEmail" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('ContactPersonEmail')">{{ errors.first('ContactPersonEmail') }}</span>
          </div>

          <div class="flex-1" style="padding-left:5px">
            <vs-input :label="$t('ContactPersonJobTitle')" v-model="customerModel.ContactPersonJobTitle" class="mt-5 w-full" name="ContactPersonJobTitle" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('ContactPersonJobTitle')">{{ errors.first('ContactPersonJobTitle') }}</span>
          </div>
          </div>
          </vx-card>
      </div>

<div class="flex-1" style="padding-left:10px">
   <vx-card :title="$t('OrganizationAdressInfo')" class="mt-base" no-shadow card-border>
     <div  class="vx-col w-full">
       <div class="flex-1" style="padding-left:5px">
            <vs-input :label="$t('Address1')" v-model="customerModel.Address1" class="mt-5 w-full" name="Address1" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Address1')">{{ errors.first('Address1') }}</span>
          </div>
          <div class="flex-1" style="padding-left:5px">
            <vs-input :label="$t('Address2')" v-model="customerModel.Address2" class="mt-5 w-full" name="Address2" />
            <span class="text-danger text-sm" v-show="errors.has('Address2')">{{ errors.first('Address2') }}</span>
          </div>
           <div class="flex-1" style="padding-left:5px">
            <vs-input :label="$t('City')" v-model="customerModel.City" class="mt-5 w-full" name="City" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('City')">{{ errors.first('City') }}</span>
          </div>

          <div class="flex-1" style="padding-left:5px">
            <vs-input :label="$t('ZipCode')" v-model="customerModel.ZipCode" class="mt-5 w-full" name="ZipCode"  />
            <span class="text-danger text-sm" v-show="errors.has('ZipCode')">{{ errors.first('ZipCode') }}</span>
          </div>
      </div>
      </vx-card>
      </div>

</div>
</div>
  </vx-card>

</div>
<div  class="w-full">


          <div id="data-list-list-view" class="data-list-container">
        <vs-prompt
            :title="$t('NewContact')"
            :accept-text="$t('Save')"
            :cancel-text="$t('Cancel')"
            @cancel="clearContactModal"
            @accept="SaveContact"
            @close="clearContactModal"
            :is-valid="validateContactForm"
            :active.sync="activePrompt">
                <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent style="max-height:75vh">
                      <div class="vx-col">
                         <p>{{$t('ContactType')}}</p>

                                     <v-select
                                          label="Name"
                                          class="mt-5 w-full"
                                            autocomplete
                                          v-model="contact.ContactType"
                                          :options="contactTypes"
                                          :reduce="ID => ID"
                                        />
                      </div>


                      <vs-input class="w-full mt-4" :label="$t('ContactText')" v-model="contact.ContactText"  name="ContactText" />
                      <span class="text-danger text-sm"  v-show="errors.has('ContactText')">{{ errors.first('ContactText') }}</span>
                    </form>
                </VuePerfectScrollbar>
          </vs-prompt>

           <vs-prompt
            :title="$t('NewAttachment')"
            :accept-text="$t('Save')"
            :cancel-text="$t('Cancel')"
            @cancel="clearAttachmentModal"
            @accept="SaveAttachment"
            @close="clearAttachmentModal"
            :is-valid="validateAttachmentForm"
            :active.sync="activePromptAttachment">
                <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent style="max-height:75vh">
                          <div class="mt-5 vx-row w-full " style="padding-left:20px">
                          <div class=" lg:w-3/4" style="padding-left:20px">
                            <vs-input :label="$t('DescriptionOfAttachment')" v-model="attachment.DescriptionOfAttachment" class="mt-5 w-full" name="DescriptionOfAttachment" v-validate="'required'" />
                            <span class="text-danger text-sm" v-show="errors.has('DescriptionOfAttachment')">{{ errors.first('DescriptionOfAttachment') }}</span>
                          </div>
                         <div class="vx-col">
                         <label class="vs-input--label">file</label>
                    <!-- {{CourseQuestionBank.AttachedPicURL}} -->
                     <vs-upload automatic :limit="1" :action="uploadUrl" :headers="UploadRequestHeader"  @on-success="successUpload" /> </div>
                      </div>

                    </form>
                </VuePerfectScrollbar>
          </vs-prompt>

   <div>
    <div class="vx-row w-full" >

<div class="vx-col md:w-1/2 w-full" >
    <vx-card :title="$t('OrganizationContact')"  v-if="!viewLoginInfo">
          <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus" @click="activePrompt=true">{{$t('AddContact')}} </vs-button>
          <vs-table ref="table"   pagination :max-items="5"  :data="getListOfCustomerContact" >
            <template slot="thead">
              <vs-th >{{$t('ContactType')}}</vs-th>
              <vs-th >{{$t('ContactText')}}</vs-th>
              <vs-th>{{$t('Action')}}</vs-th>
            </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                       <p class="product-name font-medium truncate">{{ tr.ContactType.Name }}</p>
                    </vs-td>
                  <vs-td>
                      <p class="product-name font-medium truncate">{{ tr.ContactText }}</p>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editContact(tr)" />
                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="openConfirm(tr)" />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
          </vs-table>
        </vx-card>

                <vx-card :title="$t('OrganizationContact')" v-if="viewLoginInfo">
                      <div class="flex-1"  >
                          <vs-input :label="$t('Phone')" v-model="customerModel.Contacts.Mobile" class="mt-5 w-full" name="Mobile" v-validate="'required'" />
                          <span class="text-danger text-sm" v-show="errors.has('Mobile')">{{ errors.first('Mobile') }}</span>
                      </div>
                        <div class="flex-1"  >
                          <vs-input :label="$t('Mail')" v-model="customerModel.Contacts.Email" class="mt-5 w-full" name="Email" v-validate="'required'" />
                          <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
                      </div>

                </vx-card>


</div>
<div  class="vx-col md:w-1/2 w-full" v-if="!viewLoginInfo">

      <vx-card :title="$t('Attachment')"  >
        <span class="text-warning ">{{$t('UploadCvs')}}</span>
          <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus" @click="activePromptAttachment=true">{{$t('AddAttachment')}} </vs-button>
          <vs-table ref="table"   pagination :max-items="5"  :data="getListOfCustomerAttachment">
            <template slot="thead">
              <vs-th > {{$t('AttachmentDescription')}}</vs-th>
              <vs-th >{{$t('Download')}}</vs-th>
              <vs-th>{{$t('Action')}}</vs-th>
            </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                       <p class="product-name font-medium truncate">{{ tr.DescriptionOfAttachment }}</p>
                    </vs-td>
                    <vs-td>
                       <a :href="DownUrl+tr.UrlAttachment" download target="_blank"><feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"  /></a>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="openConfirmAttachment(tr)" />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
          </vs-table>
      </vx-card>
</div>
</div>

    </div>
  </div>

</div>
</div>

    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import moduleCustomer from "@/store/user/customer/moduleCustomer.js";
import password from "../../views/components/password.vue"
import moduleLanguage from "@/store/settings/language/moduleLanguage.js";
import moduleContactType from "@/store/settings/contactType/moduleContactType.js";
import moduleNationality from "@/store/settings/nationality/moduleNationality.js";
import moduleIndustrySector from "@/store/settings/industrySector/moduleIndustrySector.js";
import { domain,mainSetting } from '@/gloabelConstant.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleUserTitle from "@/store/settings/userTitle/moduleUserTitle.js";
import modulecountry from "@/store/settings/country/moduleCountry.js";

export default {
  components: {
     vSelect,
    VuePerfectScrollbar,
    password
  },
    props:{
         customerModel: {
            type: Object,
            default: () => {}
            },
             viewLoginInfo: {
            type: Boolean,
            default: true
            },
      },
  data() {
    return {
      UploadRequestHeader:mainSetting.UploadRequestHeader,
       DownUrl:domain,
      selected: [],
       activePrompt:false,
       activePromptAttachment:false,
       settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      contact:{},
      dataForDeleted:{},
      edit:false,
      listOfCustomerContact:[],
      listOfCustomerAttachment:[],
     // ListOfContactTypes:[],
      itemsPerPage: 10,
      isMounted: false,
    uploadUrl:domain+"API/Course/UploadFile",
      // Data Sidebar

      rowDataForDelete: {},
      activeConfirm: false,
    attachment:{},

    };
  },
  computed: {
    UserTitles() {
      return this.$store.state.UserTitleList.UserTitles;
    },
    countries() {
      return this.$store.state.countryList.countries;
    },
     validateAttachmentForm() {
      return this.attachment.DescriptionOfAttachment !=undefined;
    },
    getListOfCustomerAttachment(){
      return this.customerModel.Attachments;
    },
   validateContactForm(){
       return this.contact.ContactType != undefined && this.contact.ContactText !=undefined;
   },
   isFormValid() {
      return !this.errors.any() && this.customerModel.FullName;
    },
    validateForm() {
      return !this.errors.any()
    },
    getListOfCustomerContact(){
      debugger
      return this.customerModel.CustomerContacts
    },
     languages() {
      return this.$store.state.languageList.languages;
    },
  nationalities() {
      return this.$store.state.nationalityList.nationalities;
    },
    industrySectors() {
      return this.$store.state.industrySectorList.industrySectors;
    },

    contactTypes() {
      return this.$store.state.contactTypeList.contactTypes;
    },
  },

  methods: {
     openConfirmAttachment(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.acceptAlertAttachment
      });
    },

     acceptAlertAttachment() {
      this.deleteAttachment(this.rowDataForDelete);
      this.$vs.notify({
        color: "danger",
        title: this.$t("Deletedrecord"),
         text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    deleteAttachment(data) {

      if(data.ID>0)
      {
         this.$store.dispatch("customerList/removeAttachment",  data.ID);
      }

    const ItemIndex = this.customerModel.Attachments.findIndex((p) => p.DescriptionOfAttachment == data.DescriptionOfAttachment)

          this.customerModel.Attachments.splice(ItemIndex, 1)
    },
     SaveAttachment()
    {
         if(!this.customerModel.Attachments)
            this.customerModel.Attachments=[];
         this.customerModel.Attachments.push(this.attachment);

          this.clearAttachmentModal();
    },

     clearAttachmentModal() {
      this.attachment = {}
    },

    successUpload(event) {

         this.attachment.UrlAttachment= event.target.responseText;
          this.$vs.notify({ color: 'success',
           title:this.$t("UploadSuccess"),
            text:this.$t("SuccessuploadyourAttachment") })
        },
    initValues()
    {
       this.customerModel = {
         CustomerContacts:[],
       };

    },

    SaveContact()
    {

        const isExist = this.customerModel.CustomerContacts.findIndex((p) => p.ContactTypeID == this.contact.ContactType.ID);
           if(isExist>=0)
        {
          if(this.edit)
          {
            if(this.dataForDeleted.ContactType.ID!=this.contact.ContactType.ID)
            {
              this.$vs.dialog({
                color: "warning",
                title:this.$t("Dialogwarning") ,
                text: this.$t("ThisContactAlreadyExists"),

            })
            this.contact={};
            return;
            }
          }
         // this.colorAlert = color
            else{
              this.$vs.dialog({
                color: "warning",
                title:this.$t("Dialogwarning") ,
              text: this.$t("ThisContactAlreadyExists"),
            })
            this.contact={};
            return;
            }
        }
        if(this.edit)
          {
              this.deleteContact(this.dataForDeleted);
              this.edit=false;
          }
          this.contact.ContactTypeID=this.contact.ContactType.ID;

         this.customerModel.CustomerContacts.push(this.contact);

          this.clearContactModal();
    },

     clearContactModal() {
      this.contact = {}
    },



    openConfirm(data) {

      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title:this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {

      this.deleteContact(this.rowDataForDelete);
      this.$vs.notify({
        color: "danger",
        title: this.$t("Deletedrecord"),
         text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    deleteContact(data) {

      if(data.ID>0)
      {
         this.$store.dispatch("customerList/removeContact",  data);
      }

    const ItemIndex = this.customerModel.CustomerContacts.findIndex((p) => p.ContactTypeID == data.ContactTypeID)
      //if(ItemIndex!=-1)
          this.customerModel.CustomerContacts.splice(ItemIndex, 1)
    },
    editContact(data){
    this.edit=true;
       this.contact = JSON.parse(JSON.stringify(data));
       this.dataForDeleted=JSON.parse(JSON.stringify(data));
       this.activePrompt=true;

    },

     submitData() {

      this.$validator.validateAll().then(result => {
        if (result) {

          if (this.customerModel.ID !== null && this.customerModel.ID >= 0) {
            this.$store.dispatch("customerList/updateItem", this.customerModel);
           this.initValues();
             this.$router.push('/User/Organization');
          } else {
           this.$store.dispatch("customerList/addItem", this.customerModel);
             this.initValues();
             this.$router.push('/User/Organization');
          }
        }
      });
    },

  },

  created() {

   // this.getContactTypes();
    const ID = this.$route.params.ID
     if(ID!=undefined)
     {

      this.$store.dispatch("customerList/GetItemByID", ID)
      .then(res => { this.customerModel = res.data

       })
      .catch(err => {

        if(err.response.status === 404) {
          this.user_not_found = true
          return
        }
        console.error(err) })
     }
        if (!moduleUserTitle.isRegistered) {
      this.$store.registerModule("UserTitleList", moduleUserTitle);
      moduleUserTitle.isRegistered = true;
    }
    this.$store.dispatch("UserTitleList/fetchDataListItems");
    if (!moduleCustomer.isRegistered) {
      this.$store.registerModule("customerList", moduleCustomer);
      moduleCustomer.isRegistered = true;
    }
     if (!moduleLanguage.isRegistered) {
      this.$store.registerModule("languageList", moduleLanguage);
      moduleLanguage.isRegistered = true;
    }
      if (!moduleIndustrySector.isRegistered) {
      this.$store.registerModule("industrySectorList", moduleIndustrySector);
      moduleIndustrySector.isRegistered = true;
    }
      if (!moduleNationality.isRegistered) {
      this.$store.registerModule("nationalityList", moduleNationality);
      moduleNationality.isRegistered = true;
    }
      if (!moduleContactType.isRegistered) {
      this.$store.registerModule("contactTypeList", moduleContactType);
      moduleContactType.isRegistered = true;
    }
      if (!modulecountry.isRegistered) {
      this.$store.registerModule("countryList", modulecountry);
      modulecountry.isRegistered = true;
    }
    this.$store.dispatch("countryList/fetchDataListItems");
    this.$store.dispatch("languageList/fetchDataListItems");
    this.$store.dispatch("contactTypeList/fetchDataListItems");
    this.$store.dispatch("nationalityList/fetchDataListItems");
     this.$store.dispatch("industrySectorList/fetchDataListItems");
     // this.getCountries();
     // this.getLanguages();
    //  this.getIndustrySector();
     // this.getNationalities();
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
